import React from 'react';
import styled from 'styled-components';

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const SwitchContainer = styled.label<{ $disabled: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.$disabled ? 0.5 : 1};
`;

const SwitchInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const SwitchTrack = styled.div<{ $checked: boolean; $disabled: boolean }>`
  width: 44px;
  height: 24px;
  background: ${props => 
    props.$checked 
      ? props.theme.primary 
      : props.theme.muted
  };
  border-radius: 12px;
  position: relative;
  transition: all 0.2s ease;
  border: 2px solid ${props => 
    props.$checked 
      ? props.theme.primary 
      : props.theme.border
  };
  display: flex;
  align-items: center;
  
  &:hover {
    background: ${props => 
      !props.$disabled && !props.$checked
        ? props.theme.muted + '80'
        : props.$checked
        ? props.theme.primary
        : props.theme.muted
    };
  }
`;

const SwitchThumb = styled.div<{ $checked: boolean }>`
  width: 18px;
  height: 18px;
  background: ${props => props.theme.background};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${props => props.$checked ? 'calc(100% - 18px - 2px)' : '2px'};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Switch: React.FC<SwitchProps> = ({ 
  checked, 
  onCheckedChange, 
  disabled = false, 
  className 
}) => {
  return (
    <SwitchContainer $disabled={disabled} className={className}>
      <SwitchInput
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
        disabled={disabled}
      />
      <SwitchTrack $checked={checked} $disabled={disabled}>
        <SwitchThumb $checked={checked} />
      </SwitchTrack>
    </SwitchContainer>
  );
};
